import axios from '../api';
import { getTenantSessionScope } from '../api/api1';

// Cache seat types to avoid repeated API calls
let seatTypesCache = null;
let fetchPromise = null;
let seatTypesCacheScope = '';

/**
 * Fetch seat types from backend API
 * Returns { status: [], category: [], plan_type: [] }
 */
export const getSeatTypes = async () => {
  const sessionScope = getTenantSessionScope();
  if (seatTypesCacheScope !== sessionScope) {
    seatTypesCache = null;
    fetchPromise = null;
    seatTypesCacheScope = sessionScope;
  }

  // Return cached data if available
  if (seatTypesCache) {
    return seatTypesCache;
  }

  // Return existing promise if fetch is in progress
  if (fetchPromise) {
    return fetchPromise;
  }

  // Fetch from API with tenant authentication
  const getTenantId = () => {
    try {
      const tenantInfo = JSON.parse(localStorage.getItem('tenantinfo') || '{}');
      return tenantInfo.tenant_id || tenantInfo.id || tenantInfo.tenantId ||
        localStorage.getItem('tenant-subdomain') || localStorage.getItem('tenantId');
    } catch {
      return null;
    }
  };

  fetchPromise = axios.get('/api/seat-types', {
    headers: getTenantId() ? { 'X-Tenant-ID': getTenantId().toString() } : {}
  })
    .then(response => {
      const data = response.data;
      if (seatTypesCacheScope === sessionScope) {
        seatTypesCache = data;
        fetchPromise = null;
      }
      return data;
    })
    .catch(error => {
      if (seatTypesCacheScope === sessionScope) fetchPromise = null;
      console.error('Failed to fetch seat types:', error);
      // Return fallback values
      const fallback = {
        status: [
          { value: "available", label: "Available" },
          { value: "occupied", label: "Occupied" },
          { value: "reserved", label: "Reserved" }
        ],
        category: [
          { value: "ac", label: "AC" },
          { value: "non_ac", label: "Non-AC" }
        ],
        plan_type: [
          { value: "general", label: "General" },
          { value: "reserved", label: "Reserved" }
        ]
      };
      if (seatTypesCacheScope === sessionScope) seatTypesCache = fallback;
      return fallback;
    });

  return fetchPromise;
};

/**
 * Clear the seat types cache (useful for testing or when types might change)
 */
export const clearSeatTypesCache = () => {
  seatTypesCache = null;
  fetchPromise = null;
  seatTypesCacheScope = '';
};

/**
 * Get seat status options with proper labels
 */
export const getSeatStatusOptions = async () => {
  const types = await getSeatTypes();
  return types.status || [];
};

/**
 * Get seat category options with proper labels
 */
export const getSeatCategoryOptions = async () => {
  const types = await getSeatTypes();
  return types.category || [];
};

/**
 * Get plan type options with proper labels
 */
export const getPlanTypeOptions = async () => {
  const types = await getSeatTypes();
  return types.plan_type || [];
};
